import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  GetDesign,
  GetDesignFailure,
  GetDesignSuccess,
  SetDesign,
} from './design.action';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { DesignModel } from '../../models/design-model';
import { NotificationService } from '../../core/services/notification.service';
import { NSLoginService } from '../../Clients/NS/Services/NSLogin.service';

@Injectable()
export class designeffect {
  constructor(
    private nsloginser: NSLoginService,
    private actions$: Actions,
    private notify: NotificationService
  ) {}
  getButton$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetDesign),
      mergeMap(() =>
        this.nsloginser.Getdesign().pipe(
          map((designlist: DesignModel[]) =>
            GetDesignSuccess({ DesignMod: designlist })
          ),
          catchError((error) => {
            this.notify.error('Something went wrong');
            return of(GetDesignFailure({ error }));
          })
        )
      )
    )
  );

  ////////////////////////
  updateSetting$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetDesign),
      mergeMap(({ DesignMod }) =>
        this.nsloginser.SetDesign(DesignMod).pipe(
          tap((r) => {
            this.notify.success('Design saved successfully');
          }),
          // Optionally refresh settings
          map(() => GetDesign()), // reload all after update
          catchError((error) => {
            this.notify.error('Something went wrong');
            return of(GetDesignFailure({ error }));
          })
        )
      )
    )
  );
}
